import { storage } from "../Redux/store";
import { toast } from "react-toastify";
import { fExecuteAPI } from "../Server/Apis";
import { RoundingDigitRo, WmsInboundVendorRo } from "../Redux/roStore";
import * as XLSX from "xlsx";
import {
  DMS_Vendor,
  PhysicalStockCount_Count_binsearch,
  RpDesign_binsearch_GETROW,
} from "../Server/ApiV2";
import moment from "moment";
import {
  RpDesign_getGitterColumns_trnTyp_GETROW,
  common_TransItemStockUOM_API,
} from "../Server/ApiV2";

import { vRdxUserInfo } from ".././Redux/roStore.js";
import {
  common_AccountPostingDetail_API,
  common_LocationwiseStock_API,
  common_LinkDocument_API,
} from "./../Server/ApiV2";

import { KernCAConfig } from "../Redux/roStore.js";
import { useState } from "react";

const handleError = (errMsg, needToUpdateInDb) => {
  if (needToUpdateInDb) {
    // TODO: update server about error
  }
};
const removePresist = () => {
  storage.removeItem("persist:root");
};
const fKeyTab = (event) => {
  const form = event.target.form;
  const index = [...form].indexOf(event.target);
  // console.log(index < form.length);
  if (index < form.length - 1) {
    if (event.key === "Enter") {
      // alert(form.length);
      // alert(index);
      form.elements[index + 1]?.focus();
      // event.preventDefault();
    }
  }
};
const fKeyTabInput = (event, name) => {
  if (event.key === "Enter") {
    document?.getElementsByName(name)[0]?.focus();
  }
};
const fFocusInput = (name) => {
  document?.getElementsByName(name)[0]?.focus();
};
const fcovertToNumber = (value) => {
  if (isNaN(Number(value))) {
    value = 0;
  } else {
    value = parseFloat(value);
  }
  if (isNaN(value)) value = 0;
  return Number(value);
};
const fBaseQtyCal = (B_Qty, B_PackQty) => {
  let B_BaseQty = fcovertToNumber(B_Qty) * fcovertToNumber(B_PackQty);
  return B_BaseQty;
};

//used
const fLandVal = (
  B_GrossAmt,
  B_TDiscAmt,
  B_LDiscAmt,
  B_FocAmt,
  B_ExciseTaxNetAmt
) => {
  let B_LandVal =
    fcovertToNumber(B_GrossAmt) -
    fcovertToNumber(B_TDiscAmt) -
    fcovertToNumber(B_LDiscAmt) -
    fcovertToNumber(B_FocAmt) +
    fcovertToNumber(B_ExciseTaxNetAmt);
  return B_LandVal;
};

const checkValue = (xvalue) => {
  return xvalue === undefined || xvalue === null ? "Error.." : xvalue;
};

const formatAmount = (xvalue) => {
  return xvalue.toLocaleString("en-IN");
};
//ALERT
const fAlertToast = (xIsSucccess, xMessage, result = "") => {
  if (window.innerWidth < 400 && xIsSucccess === "SUCCESS") {
    console.log("Toast blocked on mobile:", xMessage);
    return;
  }
  let vToasterStyle = {
    position: "top-right",
    autoClose:
      // xIsSucccess === "SUCCESS" || xIsSucccess === "INFO" ? 1000 : false,
      xIsSucccess === "SUCCESS" ? 300 : xIsSucccess === "INFO" ? 3000 : 10000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    progress: undefined,
    theme: "light",
    delay: 0,
  };

  if (xIsSucccess === "SUCCESS") {
    return toast.success(checkValue(xMessage), vToasterStyle);
  } else if (xIsSucccess === "FAILED") {
    console.log("result", result);
    return toast.error(checkValue(xMessage), vToasterStyle);
  } else if (xIsSucccess === "WARNING") {
    return toast.warning(checkValue(xMessage), vToasterStyle);
  } else if (xIsSucccess === "INFO") {
    return toast.info(checkValue(xMessage), vToasterStyle);
  }
};

const PdfUpload = () => {
  const { DBKernObj } = KernCAConfig();
  const iShowField = DBKernObj.DMS_ACTIVE?.Val === "N";
  if (iShowField) {
    return false;
  } else {
    return true;
  }
};
const fErrorMessage = (resp) => {
  return (
    resp?.response?.data?.Status ||
    resp?.response?.data?.message ||
    resp?.message ||
    resp?.Status ||
    resp?.Message ||
    "Error "
  );
};

const fCheck_Doc_Rights = async (xDocStatus, vRdxuserInfo, xVocTyp) => {
  var obj = {
    RNew: "Y",
    RSave: "Y",
    RDelete: xDocStatus == "ENTER" ? "Y" : "N",
    RApprove: xDocStatus == "ENTER" ? "Y" : "N",
    RPrint: "Y",
  };

  if (vRdxuserInfo?.UserGroupCode == "01") {
    return obj;
  } else {
    let vDocRightsObj = {
      vocTyp: xVocTyp,
      userGrp: vRdxuserInfo.UserGroupCode,
    };
    const vDocRights = await fExecuteAPI("DOCRIGHTS_GETROW", vDocRightsObj);

    if (vDocRights.Type === "SUCCESS") {
      if (vDocRights.ResultSet.length == 0) {
        return obj;
      } else {
        obj.RNew = vDocRights.ResultSet[0].Save;
        obj.RPrint = vDocRights.ResultSet[0].Print;
        obj.RSave =
          xDocStatus == "ENTER"
            ? vDocRights.ResultSet[0].Edit
            : vDocRights.ResultSet[0].Reverse;
        obj.RDelete = xDocStatus == "ENTER" ? vDocRights.ResultSet[0].Del : "N";
        obj.RApprove =
          xDocStatus == "ENTER" ? vDocRights.ResultSet[0].Appr : "N";

        return obj;
      }
    } else {
      return obj;
    }
  }
};

export const fCheck_Doc_Rights_001 = (xDocStatus, xVocTyp, xDocRightsArr) => {
  var obj = {
    RNew: "Y",
    RSave: "Y",
    RDelete: xDocStatus === "ENTER" ? "Y" : "N",
    RApprove: xDocStatus === "ENTER" || xDocStatus === "DRAFT" ? "Y" : "N",
    RPrint: "Y",
    RReverse: "Y",
    RClone: "Y",
  };
  const vRdxUserInfoObj = vRdxUserInfo();
  if ((vRdxUserInfoObj?.UserGroupCode).toString() === "01") {
    return obj;
  } else {
    let vDocRights = xDocRightsArr?.filter(
      (rights) => rights?.Lvl === 1 && rights?.DocTyp === xVocTyp
    );

    if (vDocRights?.length === 0) {
      vDocRights = xDocRightsArr?.filter(
        (rights) => rights?.Lvl === 2 && rights?.DocTyp === xVocTyp
      );
    }

    vDocRights = vDocRights?.length > 0 ? vDocRights : [];

    if (vDocRights?.length === 0) {
      // console.log("setObjRights", obj);
      return obj;
    } else {
      obj.RNew = vDocRights[0]?.Save;
      obj.RSave =
        xDocStatus === "ENTER" ? vDocRights[0]?.Edit : vDocRights[0]?.Reverse;
      obj.RDelete = xDocStatus === "ENTER" ? vDocRights[0]?.Del : "N";
      obj.RApprove =
        xDocStatus === "ENTER" || xDocStatus === "DRAFT"
          ? vDocRights[0]?.Appr
          : "N";
      obj.RPrint = vDocRights[0]?.Print;
      obj.RReverse = vDocRights[0]?.Reverse;
      obj.RClone = vDocRights[0]?.Clone;
      // console.log("setObjRights", obj);

      if (xDocStatus === "DRAFT" && vDocRights[0]?.Appr == "Y") {
        obj.RSave = "Y";
      }

      return obj;
    }
  }
};

const fCalculate_Detail = (
  xB_Qty,
  xB_PackQty,
  xEXRate,
  xB_URateFc,
  xB_LDiscPerc,
  xB_TDiscPerc,
  xB_FocFlag,
  xB_ExciseTaxAmt,
  xB_TaxPerc,
  xB_TaxPerc2,
  xAddCess,
  xB_Rounding,
  xSplDiscPerc = 0,
  xB_GrossAmt = 0,
  xB_GrossAmtBool = false,
  xB_LDiscAmt = 0,
  xB_LDiscAmtBool = false
) => {
  console.log("input", {
    xB_Qty,
    xB_PackQty,
    xEXRate,
    xB_URateFc,
    xB_LDiscPerc,
    xB_TDiscPerc,
    xB_FocFlag,
    xB_ExciseTaxAmt,
    xB_TaxPerc,
    xB_TaxPerc2,
    xAddCess,
    xB_Rounding,
    xSplDiscPerc,
    xB_GrossAmt,
    xB_GrossAmtBool,
    xB_LDiscAmt,
    xB_LDiscAmtBool,
  });
  const { roundingDigit } = RoundingDigitRo();
  console.log("roundingDigit", roundingDigit);
  const B_Qty = fcovertToNumber(xB_Qty);
  const B_PackQty = fcovertToNumber(xB_PackQty);
  const EXRate = fcovertToNumber(xEXRate);
  let B_URateFc = fcovertToNumber(xB_URateFc);
  let B_LDiscPerc = fcovertToNumber(xB_LDiscPerc);
  const B_TDiscPerc = fcovertToNumber(xB_TDiscPerc);
  const B_FocFlag = xB_FocFlag === "Y" ? true : false;
  const B_ExciseTaxAmt = fcovertToNumber(xB_ExciseTaxAmt);
  const B_TaxPerc = fcovertToNumber(xB_TaxPerc);
  const B_TaxPerc2 = fcovertToNumber(xB_TaxPerc2);
  const AddCess = fcovertToNumber(xAddCess);
  const B_Rounding = fcovertToNumber(xB_Rounding);
  const SplDiscPerc = fcovertToNumber(xSplDiscPerc);
  const iB_GrossAmt = fcovertToNumber(xB_GrossAmt);
  const iB_LDiscAmt = fcovertToNumber(xB_LDiscAmt);
  let B_BaseQty = B_Qty * B_PackQty;

  let B_URateLc = EXRate * B_URateFc;
  let B_GrossAmt = 0;

  if (xB_GrossAmtBool) {
    B_URateFc = 0;
    if (Number(B_Qty) !== 0) {
      B_URateFc = Number(iB_GrossAmt.toFixed(4)) / Number(B_Qty.toFixed(4));
    }
    B_URateLc = EXRate * B_URateFc;
    B_GrossAmt = B_Qty * B_URateLc;
  } else {
    B_GrossAmt = B_Qty * B_URateLc;
  }

  let B_LDiscAmt = 0;
  if (xB_LDiscAmtBool) {
    B_LDiscAmt = iB_LDiscAmt;
    B_LDiscPerc =
      B_GrossAmt === 0
        ? 0
        : (Number(iB_LDiscAmt.toFixed(4)) * 100) /
          Number(B_GrossAmt.toFixed(4));
  } else {
    B_LDiscAmt = (B_LDiscPerc / 100.0) * B_GrossAmt;
  }
  let B_TDiscAmt = (B_TDiscPerc / 100.0) * (B_GrossAmt - B_LDiscAmt);
  let B_FocAmt = B_FocFlag ? B_GrossAmt - B_LDiscAmt - B_TDiscAmt : 0;
  let B_ExciseTaxNetAmt = B_ExciseTaxAmt * B_Qty;
  let B_NetAmt =
    B_GrossAmt - B_LDiscAmt - B_TDiscAmt - B_FocAmt + B_ExciseTaxNetAmt;
  let B_TaxAmt = (B_TaxPerc / 100.0) * B_NetAmt;
  let B_TaxAmt2 = (B_TaxPerc2 / 100.0) * B_NetAmt;
  let B_NetAddCess = AddCess * B_Qty;
  let B_LandVal = B_NetAmt + B_TaxAmt + B_TaxAmt2 + B_NetAddCess;
  let SplDiscAmt = B_NetAmt * (SplDiscPerc / 100.0);

  console.log("output", {
    B_BaseQty: B_BaseQty.toFixed(2),
    B_URateLc: B_URateLc.toFixed(2),
    B_GrossAmt: B_GrossAmt.toFixed(2),
    B_LDiscAmt: B_LDiscAmt.toFixed(2),
    B_TDiscAmt: B_TDiscAmt.toFixed(2),
    B_FocAmt: B_FocAmt.toFixed(2),
    B_ExciseTaxNetAmt: B_ExciseTaxNetAmt.toFixed(2),
    B_NetAmt: B_NetAmt.toFixed(2),
    B_TaxAmt: B_TaxAmt.toFixed(2),
    B_TaxAmt2: B_TaxAmt2.toFixed(2),
    B_Rounding: B_Rounding.toFixed(2),
    B_NetAddCess: B_NetAddCess.toFixed(2),
    B_LandVal: B_LandVal.toFixed(2),
    SplDiscAmt: SplDiscAmt.toFixed(2),
    B_URateFc: B_URateFc.toFixed(5),
    B_LDiscPerc: B_LDiscPerc.toFixed(5),
  });
  return {
    B_BaseQty: B_BaseQty.toFixed(roundingDigit),
    B_URateLc: B_URateLc.toFixed(4),
    B_GrossAmt: B_GrossAmt.toFixed(roundingDigit),
    B_LDiscAmt: B_LDiscAmt.toFixed(roundingDigit),
    B_TDiscAmt: B_TDiscAmt.toFixed(roundingDigit),
    B_FocAmt: B_FocAmt.toFixed(roundingDigit),
    B_ExciseTaxNetAmt: B_ExciseTaxNetAmt.toFixed(roundingDigit),
    B_NetAmt: B_NetAmt.toFixed(roundingDigit),
    B_TaxAmt: B_TaxAmt.toFixed(roundingDigit),
    B_TaxAmt2: B_TaxAmt2.toFixed(roundingDigit),
    B_Rounding: B_Rounding.toFixed(roundingDigit),
    B_NetAddCess: B_NetAddCess.toFixed(roundingDigit),
    B_LandVal: B_LandVal.toFixed(roundingDigit),
    SplDiscAmt: SplDiscAmt.toFixed(roundingDigit),
    B_URateFc: B_URateFc.toFixed(4),
    B_LDiscPerc: B_LDiscPerc.toFixed(roundingDigit),
  };
};

export const fcheck_null_undefine_replace_empty = (xObj) => {
  const finalObject = Object.entries(xObj).reduce((acc, [key, value]) => {
    acc[key] = value == null || value == undefined ? "" : value;
    return acc;
  }, {});
  return finalObject;
};

export const hasValueInErrorMessage = (xmyObject) => {
  for (let x in xmyObject) {
    if (xmyObject[x] !== "") {
      return false;
    }
  }

  return true;
};

export const fCheck_Value_Null_Or_Undefined_ShowAlert = (xObject) => {
  const missingFields = [];

  Object.keys(xObject).forEach((key) => {
    if (xObject[key] === null || xObject[key] === undefined) {
      missingFields.push(key);
    }
  });

  if (missingFields.length > 0) {
    const message = `The following fields has null || undefine value : \n${missingFields.join(
      ", "
    )}`;
    return message;
  }
};
export const fNumber = (numericValue) => {
  const isDecimal = numericValue.includes(".");
  return isDecimal ? parseFloat(numericValue) : parseInt(numericValue, 10);
};
export const fCheck_Value_Null_Or_Undefined_SetEmpty = (xObject) => {
  const formattedData = Object.fromEntries(
    Object.entries(xObject).map(([key, value]) => [
      key,
      value === null || value === undefined ? "" : value,
    ])
  );
  return formattedData;
};

//API CHECKDUEDATE_GETROW
const GetCheck_Monthend_DueDate = async (xloc, xPostDt) => {
  let vCheckDueDateObj = {
    loc: xloc,
    postDt: moment(xPostDt).format("MM/DD/YYYY"),
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vCheckDueDateObj);
  const vCheckDueDate = await fExecuteAPI("CHECKDUEDATE_GETROW", FinalObj);
  console.log("vCheckDueDate", vCheckDueDate);
  if (vCheckDueDate?.Type?.toUpperCase() === "SUCCESS") {
    if (vCheckDueDate.Status != "" && !!vCheckDueDate.Status) {
      fAlertToast("INFO", vCheckDueDate.Status);
    }
    return true;
  } else {
    fAlertToast(
      "FAILED",
      vCheckDueDate.response.data.Status || vCheckDueDate?.Status
    );
    return false;
  }
};

export const Get_TransItemStockUOM = async (xB_Itmcd, xB_Unit, xLoc) => {
  let ApiObj = {
    itmCd: xB_Itmcd,
    loc: xLoc,
    unit: xB_Unit,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(ApiObj);
  const vRespi = await common_TransItemStockUOM_API(FinalObj);
  if (vRespi?.status === 200) {
    return vRespi?.data?.ResultSet;
  }
};

export const GetAccountPostingDetail = async (
  xVocTyp,
  xVocNo,
  setGridDataAccountDetailRows
) => {
  var vObj = {
    VocTyp: xVocTyp,
    VocNo: xVocNo,
  };
  const iAccountPostingDetail = await common_AccountPostingDetail_API(vObj);
  if (iAccountPostingDetail?.status === 200) {
    setGridDataAccountDetailRows(iAccountPostingDetail?.data?.ResultSet);
    return iAccountPostingDetail?.data?.ResultSet;
  } else {
    setGridDataAccountDetailRows([]);
    return [];
  }
};

export const GetLoctionwiseStock = async (
  xItmCd,
  xBr,
  setGridDataRows,
  xUserCd
) => {
  var vObj = {
    v_ItmCd: xItmCd,
    v_UserCd: xUserCd,
    v_Br: xBr,
  };
  const irow = await common_LocationwiseStock_API(vObj);
  if (irow?.status === 200) {
    let vID = irow?.data?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setGridDataRows(vID);
    return vID;
  } else {
    setGridDataRows([]);
    return [];
  }
};

export const GetLinkDocument = async (
  xVocTyp,
  xVocNo,
  xTrnType = "",
  setGridDataRows
) => {
  var vObj = {
    v_DocTyp: xVocTyp,
    v_DocNo: xVocNo,
    TrnType: xTrnType,
  };
  const iResp = await common_LinkDocument_API(vObj);
  if (iResp?.status === 200) {
    setGridDataRows(iResp?.data?.ResultSet);
    return iResp?.data?.ResultSet;
  } else {
    setGridDataRows([]);
    return [];
  }
};

//API CostUpdate_GETROW
const GetCostUpdate = async (sTrnTyp, xA_VocTyp, xA_VocNo) => {
  let xCostUpdateObj = {
    TrnTyp: sTrnTyp,
    VocTyp: xA_VocTyp,
    VocNo: xA_VocNo,
  };
  const vCostUpdate = await fExecuteAPI(
    "WMINV03_CostUpdate_GETROW",
    xCostUpdateObj
  );
  if (vCostUpdate.Type?.toUpperCase() === "SUCCESS") {
  } else {
    fAlertToast("FAILED", vCostUpdate.message);
  }
};
export const GetGitterColumns = async (
  setSummaryGridColumn,
  xtrnTyp = "",
  xSummary_Grid_ColumnsDummy
) => {
  const vGitterColumns = await RpDesign_getGitterColumns_trnTyp_GETROW(xtrnTyp);
  if (vGitterColumns?.status === 200) {
    if (vGitterColumns?.data?.ResultSet?.columns?.length > 0) {
      let { columns } = vGitterColumns?.data?.ResultSet;
      // columns = await columns.json();
      // return data;
      columns.forEach((obj) => {
        obj.headerClassName = "grid-header-row";
        if (obj.Typ === "D") {
          obj.valueFormatter = ({ value }) =>
            moment(value).format(obj.NumberFormat);
        } else if (obj.Typ === "N") {
          let iNumFormat =
            obj.Typ === "N"
              ? !!obj?.NumberFormat
                ? Number(obj?.NumberFormat)
                : 3
              : 3;
          obj.valueFormatter = ({ value }) => {
            return (
              Number(value)?.toFixed(iNumFormat) || Number(value)?.toFixed(3)
            );
          };
        }
      });

      // setSummaryGridColumn(columns);
      console.log("columns xtrnTyp", xtrnTyp, columns);
      setSummaryGridColumn(columns.filter((x) => x.hide === false));
    } else {
      setSummaryGridColumn(xSummary_Grid_ColumnsDummy);
      // fAlertToast("FAILED", "GitterColumns (" + xtrnTyp + ") is Empty");
    }
  } else {
    setSummaryGridColumn(xSummary_Grid_ColumnsDummy);
  }
};

export const Get_ToggleDropDown_binsearch_Load = async (
  xData,
  xType,
  xExact,
  xLoc
) => {
  let vLoaded_Cost_FreightObj = {
    Data: xData,
    Type: xType,
    Loc: xLoc,
    Exact: xExact,
  };
  //Data, Type, Loc, Exact
  let FinalObj = fcheck_null_undefine_replace_empty(vLoaded_Cost_FreightObj);
  const vbinsearchDropdownSearch = await RpDesign_binsearch_GETROW(FinalObj);
  if (vbinsearchDropdownSearch?.status === 200) {
    let GridID = [];
    if (vbinsearchDropdownSearch?.data?.ResultSet?.length > 0) {
      let GridID = vbinsearchDropdownSearch?.data?.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      return GridID;
    } else {
      return GridID;
    }
  } else {
    fAlertToast("FAILED", "Error in binsearch Api");
    return [];
  }
};
export const Get_ToggleDropDown_binsearch_Load2 = async (
  xData,
  xType,
  xExact,
  xLoc
) => {
  let vLoaded_Cost_FreightObj = {
    Data: xData,
    Type: xType,
    Loc: xLoc,
    Exact: xExact,
  };
  //Data, Type, Loc, Exact
  let FinalObj = fcheck_null_undefine_replace_empty(vLoaded_Cost_FreightObj);
  const vbinsearchDropdownSearch = await PhysicalStockCount_Count_binsearch(
    FinalObj
  );
  if (vbinsearchDropdownSearch?.status === 200) {
    let GridID = [];
    if (vbinsearchDropdownSearch?.data?.ResultSet?.length > 0) {
      let GridID = vbinsearchDropdownSearch?.data?.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      return GridID;
    } else {
      return GridID;
    }
  } else {
    fAlertToast("FAILED", "Error in binsearch Api");
    return [];
  }
};
export const ReportTitle = (ReportTitleObj) => {
  let iReportTitle = "";
  for (let key in ReportTitleObj) {
    if (ReportTitleObj[key] !== "") {
      iReportTitle += key + " = " + ReportTitleObj[key] + " ,";
    }
  }
  if (iReportTitle.length > 0) {
    iReportTitle = iReportTitle.slice(0, -1);
  }
  return iReportTitle;
};
export const ReportRemoveSequenceChar = (URl) => {
  return (
    URl.replace(/%2C/g, ",")
      .replace(/%2F/g, "/")
      // .replace(/%25/g, "%")
      .replace(/%20/g, " ")
      .replace(/%3D/g, "=")
      .replace(/%26/g, "&")
      .replace(/%23/g, "#")
      .replace(/%3A/g, ":")
  );
  // .replace(/%21/g, "!")
  // .replace(/%23/g, "#")
  // .replace(/%24/g, "$")
  // .replace(/%27/g, "'")
  // .replace(/%28/g, "(")
  // .replace(/%29/g, ")")
  // .replace(/%2B/g, "+")
  // .replace(/%2C/g, ",")
  // .replace(/%20/g, " ")
  // .replace(/%26/g, "&");
};
export const ReportUrl = (ReportObj) => {
  let iReportObj = Object.entries(ReportObj)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  return iReportObj;
};

export const FShortCutKey = (
  e,
  BtnNew = "BtnNew",
  BtnSave = "BtnSave",
  BtnApprove = "BtnApprove",
  BtnSearch = "BtnSearch",
  BtnDelete = "BtnDelete",
  BtnAudit = "BtnAudit",
  vRdxPrint = "P",
  fPrint
) => {
  if (e.altKey && e.which == 78) {
    console.log("alt+n");
    // New();
    document.getElementById(BtnNew).click();
  } else if (e.altKey && e.which == 83) {
    console.log("alt+s");
    // Save();
    document.getElementById(BtnSave).click();
  } else if (e.altKey && e.which == 65) {
    console.log("alt+a");
    // Approve()
    document.getElementById(BtnApprove).click();
  } else if (e.altKey && e.which == 82) {
    console.log("alt+r");
    // OpenSearchModal()
    document.getElementById(BtnSearch).click();
  } else if (e.altKey && e.which == 76) {
    console.log("alt+l");
    // Delete()
    document.getElementById(BtnDelete).click();
  } else if (e.altKey && e.which == 80) {
    console.log("alt+p");
    fPrint(vRdxPrint);
  } else if (e.altKey && e.which == 84) {
    console.log("alt+t");
    // Audit();
    document.getElementById(BtnAudit).click();
  }
};

export const userBasedHideField = () => {
  const { DBKernObj } = KernCAConfig();
  if (DBKernObj?.SONAS_INVOICE?.Val === "Y") {
    return true;
  } else {
    return false;
  }
};

export const DisableApproveFlag = () => {
  const { DBKernObj } = KernCAConfig();
  if (DBKernObj?.COUNTRY?.Val === "KSA") {
    return true;
  } else {
    return false;
  }
};

export const DBKernUId = (UId) => {
  const { DBKernObj } = KernCAConfig();
  // const obj = DBKern?.find((obj) => {
  //   return obj?.UId === UId;
  // });
  // if (obj?.Val === "Y") {
  //   return true;
  // } else {
  //   return false;
  // }
  if (DBKernObj?.[UId]?.Val === "Y") {
    return true;
  } else {
    return false;
  }
};
export const DBKernObj = (UId) => {
  const { DBKernObj } = KernCAConfig();
  console.log(DBKernObj?.[UId], UId);

  return DBKernObj?.[UId]?.Val === "Y";
};
export const fRoll_Rights_Checking = (xEnteryBy) => {
  const vRdxUserInfoObj = vRdxUserInfo();

  if (
    xEnteryBy != vRdxUserInfoObj?.UserID &&
    (vRdxUserInfoObj?.UserGroupCode).toString() != "01"
  ) {
    let EditOthersTrans = vRdxUserInfoObj?.UserRights?.EditOthersTrans;
    if (EditOthersTrans.ToUpper().Trim() == "N") {
      fAlertToast(
        "FAILER",
        "You dont have permission to edit other user transaction"
      );
      return false;
    } else {
      return true;
    }
  } else {
    return true;
  }
};

// className={userBasedHideFieldLutfi() ?  "hide-content" :""}
export const userBasedHideFieldLutfi = () => {
  const { DBKernObj } = KernCAConfig();
  const iShowField = DBKernObj?.WMINV03_UNITRATE_VLDT?.Val === "N";
  if (iShowField) {
    return true;
  } else {
    return false;
  }
};

export const exportToExcel = (
  data,
  fileName = "data",
  sheetName = "Sheet1"
) => {
  const workSheet = XLSX.utils.json_to_sheet(data);
  const workBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workBook, workSheet, sheetName);
  XLSX.writeFile(workBook, `${fileName}.xlsx`);
};

export const exportTable = (
  data,
  fileName = "data",
  sheetName = "Sheet1"
) => {
  const workSheet = XLSX.utils.json_to_sheet(data);

  // Auto column width
  const colWidths = Object.keys(data[1] || {}).map((key) => ({
    wch: Math.max(key.length + 2, 15),
  }));

  workSheet["!cols"] = colWidths;

  const workBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workBook, workSheet, sheetName);
  XLSX.writeFile(workBook, `${fileName}.xlsx`);
};

export const OpenPdfInDefaultApp = async (A_VocTyp, A_VocNo) => {
  let base64String = "";

  let Obj = {
    VocTyp: A_VocTyp,
    VocNo: A_VocNo,
  };

  const Resp = await DMS_Vendor(Obj);

  if (Resp?.status === 200) {
    console.log("DMS_Vendor", Resp?.data?.ResultSet);
    if (Resp?.data?.ResultSet?.length > 0) {
      base64String = Resp?.data?.ResultSet[0]?.Pdf_Base64;
    } else {
      fAlertToast("FAILED", "No Document Found");
      return;
    }
  }

  const byteCharacters = atob(base64String);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);
  const pdfBlob = new Blob([byteArray], { type: "application/pdf" });

  const pdfUrl = URL.createObjectURL(pdfBlob);

  setTimeout(() => {
    window.open(pdfUrl, "_blank");
    URL.revokeObjectURL(pdfUrl);
  }, 500);
};

const getStatusStyle = (status) => {
  switch (String(status?.toUpperCase())) {
    case "ENTER":
      return { color: "#F57F17", fontWeight: "bold" }; // Yellow (Dark Amber)
    case "POST":
      return { color: "#2E7D32", fontWeight: "bold" }; // Green (Dark Green)
    case "REJECT":
      return { color: "#C62828", fontWeight: "bold" }; // Red (Dark Red)
    case "DELETE":
      return { color: "#C62828", fontWeight: "bold" }; // Red (Dark Red)
    default:
      return { color: "#000000" };
  }
};

const getStatusStyleV1 = (status) => {
  switch (String(status?.toUpperCase())) {
    case "ENTER":
    case "PENDING":
      return { color: "#fff", fontWeight: "bold", backgroundColor: "#F57F17" }; // Yellow (Dark Amber)
    case "POST":
   case "POSTED":
      return { color: "#fff", fontWeight: "bold", backgroundColor: "#2E7D32" }; // Green (Dark Green)
    case "DELETE":
      return { color: "#fff", fontWeight: "bold", backgroundColor: "#C62828" }; // Red (Dark Red)
    case "REJECT":
      return { color: "#fff", fontWeight: "bold", backgroundColor: "#C62828" }; // Red (Dark Red)
    default:
      return { color: "#fff" };
  }
};

const getStatusStyleV3 = (status) => {
  switch (String(status?.toUpperCase())) {
    case "OPEN":
      return { color: "#fff", fontWeight: "bold", backgroundColor: "#F57F17" }; // Yellow (Dark Amber)
    case "CLOSE":
      return { color: "#fff", fontWeight: "bold", backgroundColor: "#2E7D32" }; // Green (Dark Green)
    case "DELETE":
      return { color: "#fff", fontWeight: "bold", backgroundColor: "#C62828" }; // Red (Dark Red)
    case "REJECT":
      return { color: "#fff", fontWeight: "bold", backgroundColor: "#C62828" }; // Red (Dark Red)
    default:

      return { color: "#fff" };
  }
};

const getUniqueValues = (data, key) => {
  return [
    ...new Set(
      (data ?? [])
        .map((item) => item[key])
        .filter((val) => val !== "" && val !== undefined && val !== null)
    ),
  ];
};

// Get unique boolean values (ensure booleans, not "true"/"false"/1/0)
const getUniqueValuesForBoolean = (data, key) => {
  return [
    ...new Set(
      (data ?? [])
        .map((item) => {
          const v = item?.[key];
          // normalize to boolean
          if (v === true || v === "true" || v === 1 || v === "1") return true;
          if (v === false || v === "false" || v === 0 || v === "0") return false;
          return v;
        })
        .filter((val) => val !== "" && val !== undefined && val !== null)
    ),
  ];
};

// 2) Convert boolean options to { label, value } for display
const toYesNoOptions = (boolValues) =>
  (boolValues ?? []).map((v) => ({
    value: v,
    label: v ? "Yes" : "No",
  }));

const toArrayFromCSV = (val) =>
  Array.isArray(val)
    ? val
    : (val ?? "")
        .toString()
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);

const toCSVFromArray = (arr) => (Array.isArray(arr) ? arr.join(",") : "");

const getVerifyStatusStyle = (status) => {
  switch (String(status)) {
    case "Approved":
      return {
        color: "#fff",
        fontWeight: "bold",
        backgroundColor: "#2E7D32", // Green for Approved
      };
    case "Pending":
      return {
        color: "#fff",
        fontWeight: "bold",
        backgroundColor: "#F57F17", // Amber for Pending
      };
    default:
      return { color: "#fff" };
  }
};

 const hasNonEnterStatus = (statusObj) => {
  const statusKeys = [
    "ProofRead_Status",
    "Print_Status",
    "Recieved_Status",
    "Distri_Status",
    "CN_Status",
  ];

  return statusKeys.some(key => statusObj[key] === "POST");
};

const fKeyTabEnterInput = (event, id) => {
  if (event.key === 'Enter') {
    document?.getElementById(id)?.focus();
  }
};
 

export {
  handleError,
  removePresist,
  fBaseQtyCal,
  fFocusInput,
  fKeyTab,
  fKeyTabInput,
  fcovertToNumber,
  fAlertToast,
  fLandVal,
  fCalculate_Detail,
  fCheck_Doc_Rights,
  GetCheck_Monthend_DueDate,
  GetCostUpdate,
  formatAmount,
  fErrorMessage,
  PdfUpload,
  getStatusStyle,
  getStatusStyleV1,
  getStatusStyleV3,
  getUniqueValues,
  getUniqueValuesForBoolean,
  toCSVFromArray,
  toArrayFromCSV,
  getVerifyStatusStyle,
  hasNonEnterStatus,
  fKeyTabEnterInput,
  toYesNoOptions
};
